"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadMore = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const text_ellipsis_1 = require("@src/helpers/text-ellipsis");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const ReadMore = ({ text, maxChars }) => {
    const [readMoreActive, setReadMoreActive] = react_1.default.useState(false);
    const intl = (0, react_intl_1.useIntl)();
    if (text.length <= maxChars) {
        return (0, jsx_runtime_1.jsx)("span", { children: text });
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [readMoreActive && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { children: text }), ' ', (0, jsx_runtime_1.jsx)(ReadMoreButton, { onClick: () => setReadMoreActive(false), children: intl.formatMessage({ id: 'general.read_less' }) })] })), !readMoreActive && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { title: text, children: (0, text_ellipsis_1.textEllipsis)(text, maxChars) }), (0, jsx_runtime_1.jsx)(ReadMoreButton, { onClick: () => setReadMoreActive(true), children: intl.formatMessage({ id: 'general.read_more' }) })] }))] }));
};
exports.ReadMore = ReadMore;
const ReadMoreButton = styled_components_1.default.span `
	margin-left: 0.25rem;
	cursor: pointer;
	color: ${({ theme }) => theme.color.brand1};
	word-break: keep-all;
	font-weight: bold;
`;
